import React from 'react';
import { useHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Modal from 'components/ui/Modal';
import { ContentSection, HereLink } from './LoyaltyLoggedOutModal.styles';

const LoyaltyLoggedOutModal = ({ isOpen = false, onClose = () => {}, onCtaClick }) => {
  const history = useHistory();
  const handleRedirectToClubEurostar = () => {
    if (onCtaClick) {
      onCtaClick();
    }
    history.push(`/clubeurostar/manage`, {
      prevPath: history.location.pathname,
      prevSearch: history.location.search,
      prevHash: history.location.hash
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ContentSection data-testid="not-loyalty-account" id="not-loyalty-account">
        <FormattedMessage
          id="errorBoundary.notLoggedInLoyalty"
          values={{
            here: (
              <HereLink
                data-testid="not-loyalty-account-here-link"
                id="not-loyalty-account-here-link"
                onClick={handleRedirectToClubEurostar}
              >
                <FormattedMessage id="errorBoundary.linkHere" />
              </HereLink>
            )
          }}
        />
      </ContentSection>
    </Modal>
  );
};

LoyaltyLoggedOutModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onCtaClick: PropTypes.func
};

export default LoyaltyLoggedOutModal;
